import React from 'react';
import CryptoJS from "crypto-js";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ModalBox from '../../components/Common/ModalBox';
import Button from '../../components/Common/Button';
import { formatRupiah } from '../../components/Common/utils';

import { ReactComponent as DefenderIcon } from "../../assets/icon/DSADD 1.svg";
import { ReactComponent as MoneyIcon } from "../../assets/icon/money.svg";

function ModalOrderConfirm({
    active,
    onClose,
    productData,
    orderConfirm,
    setOrderFix,
    type,
}) {
    const TokenOrderGuest = process.env.REACT_APP_TOKEN_ORDER_GUEST;

    const isLogin = localStorage.getItem('isLogin');
    const ItemDetailOrderConfirm = ({ label, value }) => {
        if (value !== "") {
            return (
                <div className="flex flex-row justify-between items-start">
                    <span className="flex flex-col w-full text-base text-[#9E9E9E]">
                        {label.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                    </span>
                    <div className="flex flex-col w-full ">
                        {typeof value === "number" ?
                            <span className="flex flex-col w-full text-right text-base font-semibold "> {formatRupiah(value)}
                            </span> :
                            value.length > 20 ?
                                <ul className="flex flex-col w-full text-right text-base font-semibold ">
                                    {value.split('|').map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                                :
                                <span className="flex flex-col w-full text-right text-base font-semibold ">
                                    {value}
                                </span>
                        }
                    </div>
                </div>
            );
        } else {
            return null;
        }
    };

    const generateSHA256Hash_Product = () => {
        const parsedObject = JSON.parse(isLogin);
        const originalString = `${orderConfirm.data}${orderConfirm.id_layanan
            }${orderConfirm.id_pembayaran}${orderConfirm.kontak}${orderConfirm.expired
            }${parsedObject?.apiKey === undefined ? TokenOrderGuest : parsedObject?.apiKey}`;
        const sha256Hash = CryptoJS.SHA256(originalString).toString();
        setOrderFix(sha256Hash);
    };

    const generateSHA256Hash_Saldo = () => {
        const parsedObject = JSON.parse(isLogin);
        const originalString = `${orderConfirm.jumlah}${orderConfirm.id_pembayaran}${orderConfirm.kontak}${orderConfirm.expired}${parsedObject?.apiKey}`;
        const sha256Hash = CryptoJS.SHA256(originalString).toString();
        setOrderFix(sha256Hash);
    };

    const generateSHA256Hash_Membership = () => {
        const parsedObject = JSON.parse(isLogin);
        const originalString = `${orderConfirm.id_layanan}${orderConfirm.membership}${orderConfirm.id_pembayaran}${orderConfirm.kontak}${orderConfirm.expired}${parsedObject?.apiKey}`;
        const sha256Hash = CryptoJS.SHA256(originalString).toString();
        setOrderFix(sha256Hash);
    };


    return (
        <ModalBox active={active} onClose={onClose}>
            <div className="flex flex-col gap-3">
                <div className="flex flex-col items-center text-darkColor">
                    <span
                        className={` text-lg font-semibold `}
                    >
                        Konfirmasi Pesanan Anda
                    </span>
                    <span
                        className={` text-sm  text-center`}
                    >
                        Pastikan data pemesanan telah sesuai, Lalu kamu bisa klik <b>Selesaikan Pembayaran</b>
                    </span>
                </div>
                <div className="flex flex-row gap-2 items-center">
                    {productData?.gambar &&
                        <LazyLoadImage
                            src={productData?.gambar}
                            alt={productData?.nama}
                            className=" object-cover sm:h-32 h-20 aspect-square rounded-lg"
                            effect="blur"
                        />
                    }
                    <div className="flex flex-col text-darkColor">
                        <span
                            className={`sm:text-2xl text-lg font-bold`}
                        >
                            {orderConfirm.layanan}
                            {( type !== "saldo" && orderConfirm.jumlah ) &&
                                <span className="opacity-60 text-sm ">{orderConfirm.jumlah === 1 ? null : "x" + orderConfirm.jumlah}</span>
                            }
                        </span>
                        <span
                            className={`sm:text-xl  text-sm `}
                        >
                            {productData?.nama}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col p-3 rounded-lg shadow-inner  bg-lightColor dark:bg-darkColor">
                    {Object.keys(orderConfirm).map((key) => {
                        if (
                            ![
                                "is_nick",
                                "harga",
                                "total_bayar",
                                "kontak",
                                "potongan_harga",
                                "jumlah",
                                "voucher",
                                "pembayaran",
                                "id_pembayaran",
                                "id_layanan",
                                "expired",
                                "gambar",
                                "gambar_pembayaran"
                            ].includes(key)
                        ) {
                            return (
                                <ItemDetailOrderConfirm
                                    key={key}
                                    label={key}
                                    value={orderConfirm[key]}
                                />
                            );
                        }
                        return null;
                    })}
                </div>
                <div className="flex flex-col p-3 rounded-lg shadow-inner  bg-lightColor dark:bg-darkColor">
                    {Object.keys(orderConfirm).map((key) => {
                        if (
                            ["harga", "kontak", "potongan_harga", 'voucher', "pembayaran"].includes(key)
                        ) {
                            return (
                                <ItemDetailOrderConfirm
                                    key={key}
                                    label={key}
                                    value={orderConfirm[key]}
                                />
                            );
                        }
                        return null;
                    })}
                    {Object.keys(orderConfirm).map((key) => {
                        if (
                            ["total_bayar"].includes(key)
                        ) {
                            return (
                                <ItemDetailOrderConfirm
                                    key={key}
                                    label={key}
                                    value={orderConfirm[key]}
                                />
                            );
                        }
                        return null;
                    })}
                    <span
                        className={`opacity-70 text-sm pt-2`}
                    >
                        *Harga sudah termasuk pajak
                    </span>
                </div>
                <div className="flex sm:flex-row flex-col justify-between rounded-lg gap-2 p-3 shadow-inner bg-lightColor dark:bg-darkColor">
                    <div className="flex flex-col justify-center">
                        <LazyLoadImage
                            src={orderConfirm.gambar_pembayaran}
                            alt={productData?.nama}
                            className=" object-contain h-8 w-16 rounded-lg"
                            effect="blur"
                        />
                    </div>
                    <div className="flex flex-col items-center gap-2 sm:items-end ">
                        <span
                            className={` text-lg font-bold `}
                        >
                            {formatRupiah(orderConfirm.total_bayar)}
                        </span>
                      
                        <div className="flex flex-row gap-2 items-center">
                            <DefenderIcon />
                            <span className=" text-xs flex-1">Pembayaran anda terjamin aman </span>
                        </div>
                    </div>
                </div>
                <Button
                            initialValue="Selesaikan Pembayaran"
                            type="fill"
                            color={'#ffffff'}
                            iconLeft={<MoneyIcon />}
                            className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  w-full text-darkColor"
                            onClick={() => {
                                if (type === "product") {
                                    generateSHA256Hash_Product()
                                } else if (type === "saldo") {
                                    generateSHA256Hash_Saldo()
                                } else if (type === "giftcard") {
                                    generateSHA256Hash_Saldo()
                                }
                                else if (type === "membership") {
                                    generateSHA256Hash_Membership()
                                }
                            }}
                        />
            </div>
        </ModalBox>
    );
}

export default ModalOrderConfirm;
